<template>
    <div class="grid">
        <div class="col-12">
            <div class="card mt-5">
                <h5>Payroll</h5>
                <div class="field grid">
                    <label for="dd" class="col-12 mb-2 md:col-3 md:mb-0 font-medium">Input Employee Name</label>
                    <div class="col-12 md:col-5">
                        <AutoComplete forceSelection placeholder="Search" id="dd" :dropdown="true" v-model="selectedAutoValue"
                        :suggestions="autoFilteredValue" @complete="searchEmployee($event)" @item-select="selectEmployee()" field="name" :disabled="isSelected"/>
                        <Button label="Remove" class="p-button-primary mr-2 ml-2" @click="clearSelected" :disabled="!isSelected"/>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Entry Date</label>
                    <div class="col-12 md:col-5">
                        <Calendar :showIcon="true" :showButtonBar="true" :disabled="disabled"
                :class="{ 'p-invalid': submitted && !form.payroll_date }" v-model="form.payroll_date" dateFormat="yy-mm-dd" />
                        <small class="p-invalid" v-if="submitted && !form.payroll_date">Payroll Date is required.</small>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Payment Method</label>
                    <div class="col-12 md:col-5">
                        <Dropdown v-model="form.payment_method" :options="paymentMethods"
                            placeholder="Select Payment Method" :class="{ 'p-invalid': submitted && !form.payment_method }"></Dropdown>
                        <small class="p-invalid" v-if="submitted && !form.payment_method">Payment Method is required.</small>
                    </div>
                </div>
            </div>
            <div class="card">
                <h4>Employee Info</h4>
                <TabView v-model:activeIndex="active" @tab-change="calculateDeduction">
                    <TabPanel header="Personal Info">
                        <PersonalInfo :model="employee" ></PersonalInfo>
                        <Button @click="setActive(1)" label="Next"/>
                    </TabPanel>
                    <TabPanel header="Income" :disabled="!isSelected">
                        <IncomeVue ref="income" :model="employee" :submitted="submitted"></IncomeVue>
                        <Button @click="setActive(2)" label="Next"/>
                    </TabPanel>
                    <TabPanel header="Deduction" :submitted="submitted" :disabled="!isSelected">
                        <DeductionVue ref="deduction" :model="employee" :additional-income="this.$refs.income.form"></DeductionVue>
                        <Button @click="saveAll" label="Save"/>
                    </TabPanel>
                </TabView>

            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import AppLayoutVue from '../../Layouts/AppLayout.vue';
import AutoComplete from 'primevue/autocomplete';
import Breadcrumb from 'primevue/breadcrumb';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import PersonalInfo from './Components/PersonalInfo';
import IncomeVue from './Components/Income.vue';
import DeductionVue from './Components/Deduction.vue';

export default{
    layout: AppLayoutVue,
    components: {
        AutoComplete, Breadcrumb, Button, TabPanel, TabView, PersonalInfo, IncomeVue, DeductionVue, Calendar, Dropdown,
    },
    data(){
        return{
            form: this.$page.props.payroll ?? {},
            active: 0,
            selectedAutoValue: this.$page.props.payroll ?  {id: this.$page.props.payroll.employee_id }  : '',
            autoFilteredValue: [],
            employee:  {bank: {}, master_bank: {},salary: {}},
            isSelected: false,
            paymentMethods: ["Cash", "Transfer"],
            submitted: false,
            isEdit: this.$page.props.payroll ? true : false,
        }
    },
    mounted(){
        this.$nextTick(() => {
            if(this.isEdit){
                this.selectEmployee();
            }
        })
    },
    methods:{
        searchEmployee(event) {
				setTimeout(() => {
					if (!event.query.trim().length) {
                        axios.get(`${this.$page.props.appUrl}api/employees`)
                        .then((data)=>{
                            this.autoFilteredValue = data.data.data;
                        });
					}
					else {
                        let filterValue = event.query.toLowerCase();
                        axios.get(`${this.$page.props.appUrl}api/employees?search=${filterValue}`)
                        .then((data)=>{
                            this.autoFilteredValue = data.data.data;
                        });
					}
				}, 250);
			},
        selectEmployee(){
            this.isSelected = true;
            let employee_id = this.selectedAutoValue.id;

            axios.get(`${this.$page.props.appUrl}api/employees/${employee_id}`)
            .then((data) => {
                this.employee = data.data.data;
                this.selectedAutoValue = data.data.data;
            });
        },
        clearSelected(){
            this.selectedAutoValue = '';
            this.form = {};
            this.employee = {bank: {}, master_bank: {},salary: {}};
            this.$refs.deduction.form = {total_work_days: 20};
            this.isSelected = false;

            this.active=0;
        },
        saveAll(){
            this.submitted = true;
            let income = this.employee.salary;
            let additional_income = this.$refs.income.form;
            let deduction = this.$refs.deduction.form;

            // Function to remove key from array so they dont overlap with income vaiable
            delete deduction.fixed_allowance;
            delete deduction.functional_allowance;
            delete deduction.transport_allowance;
            delete deduction.meal_allowance;
            delete deduction.special_allowance;
            delete deduction.communication_allowance;
            delete deduction.insentive;
            delete deduction.leftover_salary;
            delete deduction.overtime_hour;
            delete deduction.overtime_money;
            delete deduction.dayoff_overtime_hour;
            delete deduction.dayoff_overtime_money;
            delete deduction.net_salary;
            delete deduction.salary;

            let validated = true;

            if(!this.selectedAutoValue){
                validated = false;
            }

            if(!this.form.payroll_date || !this.form.payment_method){
                validated = false;
            }

            if(validated){
                this.submitted = false;

                let payload = {...this.form, employee_id: this.employee.id, ...income, ...additional_income, ...deduction };

                if(!this.isEdit){
                    axios.post(`${this.$page.props.appUrl}api/payrolls`,payload)
                    .then((data) => {
                        this.clearSelected();
                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: "Payroll Created",
                            life: 3000,
                        });
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error When Creating Payroll",
                            detail: error,
                            life: 3000,
                        });
                    });
                }else{
                    axios.put(`${this.$page.props.appUrl}api/payrolls/${this.$page.props.payroll.id}`,payload)
                    .then((data) => {
                        this.clearSelected();
                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: "Payroll Updated",
                            life: 3000,
                        });
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error When Updating Payroll",
                            detail: error,
                            life: 3000,
                        });
                    });
                }

            }
        },
        setActive(index){
            this.calculateDeduction();
            this.active = index;
        },
        calculateDeduction (){
            if(this.isEdit){
                this.$refs.deduction.form.is_jht = this.$page.props.payroll.is_jht ? true : false;
                this.$refs.deduction.form.is_jp = this.$page.props.payroll.is_jp ? true : false;
                this.$refs.deduction.form.is_bpjs_kesehatan = this.$page.props.payroll.is_bpjs_kesehatan ? true : false;
                this.$refs.deduction.form.is_pph21 = this.$page.props.payroll.is_pph21 ? true : false;
            }else{
                this.$refs.deduction.form.is_jht = this.employee.salary.is_jht ? true : false;
                this.$refs.deduction.form.is_jp = this.employee.salary.is_jp ? true : false;
                this.$refs.deduction.form.is_bpjs_kesehatan = this.employee.salary.is_bpjs_kesehatan ? true : false;
                this.$refs.deduction.form.is_pph21 = this.employee.salary.is_pph21 ? true : false;
            }

            this.$refs.deduction.setBpjsJhtValue();
            this.$refs.deduction.setBpjsJpValue();
            this.$refs.deduction.setBpjsKesehatanValue();
            this.$refs.deduction.setPPH21Value();
        }
    }
}
</script>
